import styled from 'styled-components'
import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const RadioTilesWrapper = styled.div<{ optionsCount: number }>`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(${(p) => p.optionsCount}, 1fr);
  border-radius: 8px;
  overflow: hidden;
`
export const RadioTileLabel = styled.label`
  display: flex;
  flex-direction: row;
  width: 100%;
  background: ${theme.colors.white};
  transition: 0.3s;
  user-select: none;
  &:first-child > span {
    border-radius: 8px 0 0 8px;
  }
  &:last-child > span {
    border-radius: 0 8px 8px 0;
  }
  & > input:checked ~ span {
    color: ${theme.colors.horizonOrange};
    border: 1px solid ${theme.colors.horizonOrange};
    background: #fdf5f0;
  }
`
export const RadioTileInput = styled.input`
  display: none;
`

export const RadioTileCheckmark = styled.span`
  display: flex;
  color: ${theme.colors.moreGrey};
  align-items: center;
  justify-content: center;
  ${Font14};
  font-weight: 900;
  transition: 0.3s;
  cursor: pointer;
  padding: 8px 0;
  width: 100%;
  border: 1px solid ${theme.colors.pelicanGrey};
`
